import moment from 'moment';
import { UploadOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Upload,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import styled from 'styled-components';
import { checkCorporateNumber } from '../../util/utils';

const { Option } = Select;

const StyledDiv = styled.div`
  .ant-select-selector {
    white-space: pre-wrap;
    height: fit-content !important;
  }

  .ant-select-selection-item {
    white-space: pre-wrap;
  }

  .ant-select-item-option-content {
    white-space: pre-wrap;
  }
`;

interface TaxInvoiceCreateUpdateComponentProps {
  taxInvoice?: any;
  uploadProps: any;
  onCreate: (data: any) => void;
  onCancel: () => void;
}

function TaxInvoiceCreateUpdateComponent({
  taxInvoice,
  uploadProps,
  onCreate,
  onCancel,
}: TaxInvoiceCreateUpdateComponentProps) {
  const [form] = Form.useForm();
  let _taxInvoice: any;

  if (!!taxInvoice) {
    _taxInvoice = {
      ...taxInvoice,
      reportingDate: moment(taxInvoice.reportingDate, 'YYYY-MM-DD'),
      price: taxInvoice.supplyValue + taxInvoice.taxAmt,
    };
  } else {
    _taxInvoice = {
      reportingDate: moment(),
    };
  }

  const normFile = (e: any) => {
    let fileList = e.fileList;
    if (Array.isArray(e)) {
      return e;
    }
    return e && fileList;
  };

  const updatePriceField = () => {
    const price = form.getFieldValue('price');
    const supplyValue = Math.round(price / 1.1);
    const taxAmt = price - supplyValue;
    form.setFieldsValue({
      taxAmt,
      price,
      supplyValue,
    });
  };

  const updateSupplyPriceField = () => {
    const supplyValue = form.getFieldValue('supplyValue');
    const taxAmt = Math.round(supplyValue * 0.1);
    const price = supplyValue + taxAmt;
    form.setFieldsValue({
      taxAmt,
      price,
      supplyValue,
    });
  };

  const updateVatField = () => {
    const price = form.getFieldValue('price');
    const taxAmt = form.getFieldValue('taxAmt');
    const supplyValue = price - taxAmt;
    form.setFieldsValue({
      taxAmt,
      price,
      supplyValue,
    });
  };

  return (
    <StyledDiv>
      <Form
        form={form}
        layout="vertical"
        onFinish={onCreate}
        initialValues={_taxInvoice}
      >
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="reportingDate"
              label="작성일"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name="supplierRegNumber"
              label="공급자 등록번호"
              rules={[
                {
                  validator: (_, value) => checkCorporateNumber(value),
                },
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="예) 3493901068" />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="supplierCompanyName"
              label="공급자 상호"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="예) 하이공사" />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name="supplierName"
              label="공급자 대표명"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="예) 홍길동" />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item name="repItems" label="대표품목">
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="type"
              label="종류"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>
                <Option value="0">전자세금계산서</Option>
                <Option value="1">현금영수증</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item name="approvalNo" label="승인번호">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="price"
              label="합계 금액(환불 시 마이너스 금액 입력)"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                formatter={(value) =>
                  `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                onChange={updatePriceField}
              />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name="supplyValue"
              label="공급가액(환불 시 마이너스 금액 입력)"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                formatter={(value) =>
                  `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                onChange={updateSupplyPriceField}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="taxAmt"
              label="부가세(환불 시 마이너스 금액 입력)"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                formatter={(value) =>
                  `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                onChange={updateVatField}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="file"
              label="첨부파일"
              valuePropName="fileList"
              getValueFromEvent={normFile}
            >
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined rev={undefined} />}>
                  파일 올리기
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Form.Item>
            <Space size="middle">
              <Button htmlType="button" onClick={onCancel}>
                취소
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100px' }}
              >
                확인
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </StyledDiv>
  );
}
export default TaxInvoiceCreateUpdateComponent;
